<template>
    <div id="app">
		<keep-alive :include="include">
			<router-view v-if="$route.meta.keepAlive"/>
		</keep-alive>
		<router-view v-if="!$route.meta.keepAlive"/>
    </div>
</template>

<script>
export default {
	name: "app",
	data: () => ({
		include: ['Home']
	}),
	watch: {
		$route(to, from) {
			console.log(to)
			//如果 要 to(进入) 的页面是需要 keepAlive 缓存的，把 name push 进 include数组
			if (to.meta.keepAlive) {
				!this.include.includes(to.name) && this.include.push(to.name);
			}
			//如果 要 form(离开) 的页面是 keepAlive缓存的，
			//再根据 deepth 来判断是前进还是后退
			//如果是后退
			if (from.meta.keepAlive && to.meta.deepth <= from.meta.deepth) {
				var index = this.include.indexOf(from.name);
				index !== -1 && this.include.splice(index, 1);
			}
		}
	}
}
</script>

<style>
	.icon {
		font-size: 23px;
		color: #333;
	}
	/* 清除默认样式 */
	p {
		padding: 0;
		margin: 0;
	}
	input {
		outline-color: invert;
		outline-style: none;
		outline-width: 0px;
		border: none;
		border-style: none;
		text-shadow: none;
		-webkit-appearance: none;
		-webkit-user-select: text;
		outline-color: transparent;
		box-shadow: none;
	}
	button {
		margin: 0;
		padding: 0;
		border: 1px solid transparent;
		outline: none;
	}
	img{ pointer-events: none; }
	
</style>
